$.onmount("[data-component=product-select-all]", function() {
  var $el = $(this)

  function productLabel(item, escape) {
    var labels = []

    if (item.name) labels.push(item.name)
    if (item.sku) labels.push('SKU: ' + item.sku)
    if (item.barcode) labels.push('JAN: ' + item.barcode)

    return escape(labels.join(' / '))
  }

  function onLoad(query, callback) {
    $.ajax({
      url: "/products/search_products_to_select",
      dataType: "JSON",
      data: {
        keyword: query
      },
      success: callback,
      error: callback
    })
  }

  $el.selectize({
    load: onLoad,
    valueField: "id",
    labelField: "name",
    searchField: ["name", "barcode", "sku"],
    options: [],
    create: false,
    preload: "focus",
    placeholder: "Search products here..",
    render: {
      option: function(item, escape) {
        return '<div>' + productLabel(item, escape) + '</div>'
      },
      item: function(item, escape) {
        return '<div>' + productLabel(item, escape) + '</div>'
      }
    }
  })

  var preload = $el.data("preload")
  var productId = $el.data('product-id')

  if (preload) {
    $el[0].selectize.addOption(preload)
  }
  if (productId)
    $el[0].selectize.setValue(productId, true)
})
